/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setErrorLoadImage } from '../app/mainSlice';

const ProductImage = props => {
    const imgRef = useRef(null);
    const dispatch = useDispatch();

    return (
        <img
            ref={imgRef}
            className={
                'product-image' +
                (props.imageErrorMessage ? ' product-no-image' : '') +
                (props.lensErrorMessage ? ' lens-error-image' : '')
            }
            src={props.src}
            alt={props.alt}
            onLoad={() => {
                if (imgRef.current.naturalWidth < props.imgWidth) {
                    props.handleError();
                    if (props.isBrandSelection) dispatch(setErrorLoadImage(true));
                } else {
                    if (props.isBrandSelection) dispatch(setErrorLoadImage(false));
                }
            }}
        />
    );
};

export default ProductImage;
